import axios from "axios";

import {
  RemoveFileParams,
  UpdateDescriptionParams,
  UploadFileParams,
} from "./types";

import { download } from "../../../helpers/files";

export const uploadFile = ({
  path,
  tempId,
  file,
  cb,
}: UploadFileParams): Promise<{ id: string }> => {
  const formData = new FormData();

  formData.append("DocumentToUpload", file);

  return axios
    .post(`documents/${path}`, formData, {
      onUploadProgress: (progressEvent: ProgressEvent) => {
        const percents = Math.round(
          (progressEvent.loaded / progressEvent.total) * 100
        );

        cb((prevState) => ({
          ...prevState,
          [tempId]: percents,
        }));
      },
    })
    .then((res) => res.data);
};

export const uploadDraftFile = ({
  key,
  path,
  tempId,
  file,
  cb,
}: UploadFileParams): Promise<{ path: string }> => {
  const formData = new FormData();

  formData.append(key, file);

  return axios
    .post<{ sources: string[] }>(path, formData, {
      onUploadProgress: (progressEvent: ProgressEvent) => {
        const percents = Math.round(
          (progressEvent.loaded / progressEvent.total) * 100
        );

        cb((prevState) => ({
          ...prevState,
          [tempId]: percents,
        }));
      },
    })
    .then((res) => ({
      id: res.data.sources?.[0],
      path: res.data.sources?.[0],
    }));
};

export const updateFileDescription = ({
  id,
  path,
  description,
}: UpdateDescriptionParams): Promise<UpdateDescriptionParams> =>
  axios
    .patch(`documents/${path}/${id}/description`, {
      description,
    })
    .then((res) => res.data);

export const removeFile = ({ id, path }: RemoveFileParams): Promise<unknown> =>
  axios.delete(`documents/${path}/${id}`).then((res) => res.data);

export const downloadFile = (id: string, path: string, fileName: string) =>
  axios
    .get(`documents/${path}/${id}`, {
      responseType: "blob",
      hideToast: true,
    })
    .then((res) => download(fileName, res));

export const downloadDraftFile = (path: string, fileName: string) =>
  axios
    .get(path, {
      responseType: "blob",
      hideToast: true,
    })
    .then((res) => download(fileName, res));
